import { WithEnterpriseId, WithServiceId } from '@mews-commander/types';
import { useRepositoryQuery } from '@mews-commander/data-access';

export const useDefaultRateQuery = ({ enterpriseId, serviceId }: WithEnterpriseId & WithServiceId) =>
    useRepositoryQuery(
        'rates',
        'getAll',
        {
            serviceIds: [serviceId],
            enterpriseIds: [enterpriseId],
        },
        {
            select: ({ rates }) => (rates ? rates.find((rate) => rate.isDefault) : undefined),
        }
    );
